import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="social-box p-4">
          <div className="text-sm font-bold" style={{ color: '#ef4444' }}>Something went wrong</div>
          <pre className="text-2xs font-mono mt-2 p-2" style={{ background: 'var(--bg-filter)', color: 'var(--text-secondary)', overflow: 'auto' }}>
            {this.state.error?.message}
          </pre>
          <button
            className="mt-2 text-2xs font-bold px-3 py-1"
            style={{ background: 'var(--accent)', color: 'var(--text-inverse)', cursor: 'pointer' }}
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
